import type { SyntheticEvent } from 'react'

import { Computed, Observer } from 'shared/observer'

let menu: HTMLDivElement | null = null

const lastTrigger = new Observer<HTMLElement | null>(null)

const openId = new Computed(lastTrigger, button => button?.dataset.id ?? '')

let timeoutId: number = Number.NaN

function manualSet(element: typeof menu) {
	menu = element
}

function open(event: SyntheticEvent<HTMLElement>) {
	const trigger = event.currentTarget

	clearTimeout(timeoutId)

	timeoutId = window.setTimeout(() => {
		lastTrigger.value?.focus()
		lastTrigger.value = trigger

		menu?.showPopover()
	}, 400)
}

const close = () => {
	lastTrigger.value = null
	menu?.hidePopover()
}

const isActive = () =>
	menu?.contains(document.activeElement) || menu?.matches(':hover')

const onTriggerClose = (_event: SyntheticEvent<HTMLElement>) => {
	if (!isActive()) {
		close()
	}
}

function closeOnBlur() {
	const hoveredTrigger = lastTrigger.value?.matches(':hover')

	if (!hoveredTrigger) {
		close()
	}
}

export {
	close,
	closeOnBlur,
	lastTrigger,
	manualSet,
	menu,
	onTriggerClose,
	open,
	openId
}
